import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class AreaApi {
  /**
   * @deprecated Use GetAreasFilter instead for better performance with server-side pagination.
   */
  static async GetAllAreas(): Promise<any> {
    return ApiHandler(baseURL).get("/v1/areas/all");
  }

  static async GetAreasFilter(params: any): Promise<any> {
    return ApiHandler(baseURL).get("/v1/areas/filter", { params });
  }

  static async GetAreaById(id: string): Promise<any> {
    return ApiHandler(baseURL).get("/v1/areas/" + id);
  }

  static async GetAreaByProductionUnit(unitId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/areas/production-unit/${unitId}`);
  }

  static async GetAreaByPlantIdStatic(plantId: string): Promise<any> {
    return ApiHandler(baseURL).get(`/v1/areas/plant/${plantId}`);
  }

  static async CreateArea(
    productionUnitId: string,
    name: string,
  ): Promise<any> {
    return ApiHandler(baseURL).post("/v1/areas", {
      productionUnitId,
      name,
    });
  }

  static async UpdateArea(
    id: string,
    productionUnitId: string,
    name: string,
  ): Promise<any> {
    return ApiHandler(baseURL).put(`/v1/areas/${id}`, {
      productionUnitId,
      name,
    });
  }

  static async DeleteArea(areaId: string): Promise<any> {
    return ApiHandler(baseURL).delete(`/v1/areas/${areaId}`);
  }
}
